var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { equals, map, propEq, find } from "ramda";
import Button from "components/button";
import Icon from "components/icon";
import Loader from "components/loader";
import GiftCardRow from "components/online_ordering/checkout/gift_card_row";
import { RequestStatus } from "types/requests";
var StyledForm = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .row {\n    display: block;\n  }\n  .row > button {\n    width: 6.5rem;\n  }\n  .row > div {\n    width: 100%;\n  }\n  .gift-card-header {\n    max-height: 21px;\n    display: flex;\n    .icon-wrapper {\n      margin: 0 0 0 12px;\n    }\n  }\n  label,\n  .applied-code {\n    line-height: 2rem;\n  }\n  min-height: 3rem;\n\n  .loader:before {\n    content: \"\";\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: radial-gradient(\n      rgba(224, 224, 224, 0.8),\n      rgba(224, 224, 224, 0.8)\n    );\n\n    background: -webkit-radial-gradient(\n      rgba(224, 224, 224, 0.8),\n      rgba(224, 224, 224, 0.8)\n    );\n  }\n  .loader {\n    position: fixed;\n    z-index: 999;\n    height: 2em;\n    width: 2em;\n    overflow: visible;\n    margin: auto;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    .logo {\n      top: 0;\n    }\n  }\n  .loader .indicator:after {\n    top: 0;\n  }\n"], ["\n  .row {\n    display: block;\n  }\n  .row > button {\n    width: 6.5rem;\n  }\n  .row > div {\n    width: 100%;\n  }\n  .gift-card-header {\n    max-height: 21px;\n    display: flex;\n    .icon-wrapper {\n      margin: 0 0 0 12px;\n    }\n  }\n  label,\n  .applied-code {\n    line-height: 2rem;\n  }\n  min-height: 3rem;\n\n  .loader:before {\n    content: \"\";\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: radial-gradient(\n      rgba(224, 224, 224, 0.8),\n      rgba(224, 224, 224, 0.8)\n    );\n\n    background: -webkit-radial-gradient(\n      rgba(224, 224, 224, 0.8),\n      rgba(224, 224, 224, 0.8)\n    );\n  }\n  .loader {\n    position: fixed;\n    z-index: 999;\n    height: 2em;\n    width: 2em;\n    overflow: visible;\n    margin: auto;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    .logo {\n      top: 0;\n    }\n  }\n  .loader .indicator:after {\n    top: 0;\n  }\n"])));
var StyledSubheader = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: 600;\n  font-size: 1rem;\n  text-transform: uppercase;\n  grid-area: header;\n  margin-bottom: 8px;\n"], ["\n  font-weight: 600;\n  font-size: 1rem;\n  text-transform: uppercase;\n  grid-area: header;\n  margin-bottom: 8px;\n"])));
function GiftCard(_a) {
    var applyGiftCard = _a.applyGiftCard, balanceDue = _a.balanceDue, giftCards = _a.giftCards, giftCardStatus = _a.giftCardStatus, removeGiftCard = _a.removeGiftCard;
    var _b = useState(giftCards), giftCardsList = _b[0], setGiftCardsList = _b[1];
    var _c = useState(true), showAddButton = _c[0], setShowAddButton = _c[1];
    var blankGiftCard = {
        index: giftCards.length,
        giftCardNumber: "",
        pin: "",
    };
    useEffect(function () {
        setGiftCardsList(giftCards);
        if (giftCards.length < 2 && balanceDue > 0) {
            setShowAddButton(true);
        }
        else {
            setShowAddButton(false);
        }
    }, [giftCards, balanceDue]);
    var isLoading = equals(giftCardStatus, RequestStatus.REQUESTING);
    return (React.createElement(StyledForm, { className: "form" },
        isLoading && React.createElement(Loader, null),
        React.createElement("div", { className: "gift-card-header" },
            React.createElement(StyledSubheader, null, "Pay with gift card"),
            React.createElement(Icon, { type: "gift-card-balance" })),
        React.createElement("div", { className: "row" },
            giftCardsList &&
                map(function (idx) {
                    var card = find(propEq("index", idx), giftCardsList);
                    if (card) {
                        return (React.createElement(GiftCardRow, { applyGiftCard: applyGiftCard, key: "card" + idx, giftCard: card, giftCards: giftCards, giftCardStatus: giftCardStatus, removeGiftCard: removeGiftCard }));
                    }
                    return null;
                }, [0, 1]),
            showAddButton && (React.createElement(Button, { className: "caps", type: "primary", onClick: function () {
                    setShowAddButton(false);
                    setGiftCardsList(__spreadArrays(giftCardsList, [__assign({}, blankGiftCard)]));
                } }, "+Add")))));
}
export default withLDConsumer()(GiftCard);
var templateObject_1, templateObject_2;
